module.exports = __webpack_public_path__ + "static/media/kids.765d9a52.png";